import { styled } from '@mui/material';

export const ContentTitleStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '87px',
  paddingLeft: '32px',
  borderBottom: 'solid 1px #E9EAEE',
  flexShrink: 0,
  [theme.breakpoints.down('lg')]: {
    paddingLeft: '20px'
  },
  '& > h6': {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '160%',
    letterSpacing: '0.15px',
    color: '#1C3D64',
    minWidth: '200px'
  }
}));
